import {Injectable} from '@angular/core';
import firebase from 'firebase';
import { timer } from 'rxjs';
import { first } from 'rxjs/operators';
import { QualtricsOrder } from 'src/app/data/networking/models/qualtrics/qualtrics';

@Injectable({
  providedIn: 'root',
})
export class QualtricsVm {
  qualtricsScript: HTMLScriptElement;

  tryConfig(milis:number){
    return timer(milis)
      .pipe(first());
  }
  async fetchAndActivate(remoteConfig:firebase.remoteConfig.RemoteConfig): Promise<{ qualtricsActive: boolean;}> {
    remoteConfig.settings = {
      minimumFetchIntervalMillis: 60 * 1000,
      fetchTimeoutMillis: 60 * 1000,
    };
    await remoteConfig.fetchAndActivate();
    const qualtricsActive = remoteConfig.getBoolean('qualtrics_active');
    return {qualtricsActive};
  }
  setQualtricsData(window ,item: QualtricsOrder, orderDate: string): void{
    window.QSI.API.param('order_status', item.lastStatus);
    window.QSI.API.param('order_id', item.idOrder);
    window.QSI.API.param('billing_date',orderDate);
    window.QSI.API.param('idAddress', item.idAddress);
    window.QSI.API.param('payment_method_id', item.paymentType.id);
    window.QSI.API.param('idStoreGroup', item.idStoreGroup);
    window.QSI.API.param('deliveryType', item.deliveryType);
    window.QSI.API.selector='#qualtricsFeedback';
  }
  addScript(){
    this.qualtricsScript = document.createElement("script");
    this.qualtricsScript.src = "/assets/plugins/qualtrics/sdk.js";
    document.body.appendChild(this.qualtricsScript);
  }
}
